import type { IntegrationSettings } from '@vy/types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { raise, validateNotNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { useIntegrationSettings } from '../../../../../../../hooks/requests/use-integration-settings';
import type { SlackConfigurationFormValues } from '../SlackConfigurationFormSchema';
import { IntegrationsSettings } from '@vy/integrations-types';

type FetchSlackSettingsResult = {
  integrationId: string;
  configuration: SlackConfigurationFormValues;
};

export function useFetchSlackSettings(): FetchSlackSettingsResult {
  const integrationSettingsResponse = useIntegrationSettings(INTEGRATION_PROVIDERS.slack);
  const slackIntegrationSettings = integrationSettingsResponse.data;

  validateNotNullOrUndefined(slackIntegrationSettings, 'slackIntegrationSettings');

  const { integrationId, integrationSettings } = slackIntegrationSettings;

  return useMemo(
    () => ({
      integrationId,
      configuration: mapIntegrationSettingsToFormValues(integrationSettings),
    }),
    [integrationId, integrationSettings],
  );
}

function mapIntegrationSettingsToFormValues(
  integrationSettings: IntegrationSettings | IntegrationsSettings,
): SlackConfigurationFormValues {
  if (integrationSettings.integrationProvider !== INTEGRATION_PROVIDERS.slack) {
    raise(`Invalid integration provider ${integrationSettings.integrationProvider}`);
  }

  return {
    channelId: integrationSettings.integrationConfiguration.channelId || '',
  };
} 